import React from 'react';

import { DESC } from '../constants';

class SearchableTable extends React.Component {

  descendingComparator = (a, b, orderBy) => {
    let aValue = a[orderBy];
    let bValue = b[orderBy];
    const aType = typeof aValue;
    const bType = typeof bValue;
    if (aValue !== undefined && aType === 'string') {
      if (
        (orderBy === 'price' ||
          orderBy === 'minimumPrice' ||
          orderBy === 'maximumPrice') &&
        !isNaN(parseFloat(aValue))
      ) {
        aValue = parseFloat(aValue);
      } else {
        aValue = a[orderBy].toLowerCase();
      }
    }
    if (bValue !== undefined && bType === 'string') {
      if (
        (orderBy === 'price' ||
          orderBy === 'minimumPrice' ||
          orderBy === 'maximumPrice') &&
        !isNaN(parseFloat(bValue))
      ) {
        bValue = parseFloat(bValue);
      } else {
        bValue = b[orderBy].toLowerCase();
      }
    }
    if (aType === 'boolean' && bType === 'boolean') {
      if (!bValue && aValue) {
        return 1;
      } else if (bValue && !aValue) {
        return -1;
      } else {
        return 0;
      }
    }
    if (bValue < aValue || (!bValue && aValue)) {
      return -1;
    } else if (bValue > aValue || (bValue && !aValue)) {
      return 1;
    } else {
      return 0;
    }
  };

  getComparator = (order, orderBy) => {
    return order === DESC
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy);
  };

  stableSort = (array, comparator) => {
    if (!array) return [];
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  };

  /**
   * Applies filter to the table using the search field input. This method searches ALL the keys of the data
   *
   * @param rows the data against which filters are to be applied
   */
  filterBySearch(rows) {
    if (!rows) return [];
    const searchText = this.state.searchValue.toLowerCase();
    if (searchText === '') {
      return rows;
    }
    // for each row in rows
      return rows.filter((row) => {
      // traverse every key of the row as an array and match the search text against the value corresponding key
      // note: here are only searching the "filter" and not other hidden properties
      return (
        Object.keys(row).findIndex((key) => {
          return (
            row &&
            row[key] &&
            (JSON.stringify(row[key]).toLowerCase().includes(searchText) ||
              JSON.stringify(row[key])
                .toLowerCase()
                .includes(searchText.replace(',', '')))
          );
        }) !== -1
      );
    });
  }

  checkValueObject(value, searchText) {
    if (typeof value === 'object' && value !== null && value !== undefined) {
      return (
        Object.values(value).findIndex((nextValue) => {
          return this.checkValueObject(nextValue, searchText);
        }) !== -1
      );
    } else {
      return JSON.stringify(value).toLowerCase().includes(searchText);
    }
  }
}

export default SearchableTable